<template>
    <div class="updatePassword">
      <el-form :model="passwordFrom" :rules="passwordFromRules" ref="passwordFrom" label-width="150px">

        <el-form-item prop="oldPass" label="旧密码">
          <el-input v-model="passwordFrom.oldPass"></el-input>
        </el-form-item>
        <el-form-item prop="newPass" label="新密码">
          <el-input v-model="passwordFrom.newPass"></el-input>
        </el-form-item>
        <el-form-item prop="newPassOK" label="确认新密码">
          <el-input v-model="passwordFrom.newPassOK"></el-input>
        </el-form-item>
      </el-form>
      <div class="action">
        <el-button @click="sendUpdate" type="primary">修改密码</el-button>
      </div>
    </div>
</template>

<script>
import {post} from "../../../utils/request";

export default {
  name: "updatePassword",
  data() {
    return {
      passwordFrom: {},
      passwordFromRules:{
        oldPass: [
          { required: true, message: '请上输入旧密码！', trigger: 'blur' },
        ],
        newPass: [
          { required: true, message: '请上输入新密码！', trigger: 'blur' },
        ],
        newPassOK: [
          { required: true, message: '请确认新密码！', trigger: 'blur' },
        ],
      }
    }
  },
  methods:{
    sendUpdate(){
      this.$refs.passwordFrom.validate(v=>{
        if (v){
          if (this.passwordFrom.newPass !==this.passwordFrom.newPassOK){
            this.$message.error("两次密码不一致！")
          }else {
            post('/gateway/password/reset',this.passwordFrom).then(res=>{
              if (res.code===0){
                this.passwordFrom = {}
                this.$message.success("修改成功！")
              }else {
                this.$message.error(res.msg)
              }
            })
          }
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.updatePassword{
  border: 1px solid #cecece;
  padding-top: 30px;
}
.action{
    display: flex;
  justify-content: center;
  margin-top: 120px;
  padding-bottom: 40px;
}
::v-deep .el-form-item__label{
  font-size: 20px !important;
}
::v-deep  .el-input__inner{
    width: 400px !important;
}
::v-deep .el-button--primary{
  border-radius: 26px;
}
::v-deep .el-message{
  position: relative;
  z-index: 999999999!important;
}
</style>
